import React from 'react';

export interface IAlarm {
    id: string;
    alarmName: string;
    alarmText: string;
    type: string;
    isActive: boolean;
    createDate: string;
    smartlinkCategory: string;
    color?: string | null;
}

interface AlarmsCardProps {
    alarms: IAlarm[];
}

const AlarmsCard: React.FC<AlarmsCardProps> = ({ alarms }) => {
    const formatDate = (dateString: string): string => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleDateString('en-US', { month: 'short' });
        const year = date
            .getFullYear()
            .toString()
            .slice(-2);
        const time = date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
        return `${day}-${month}-${year} ${time}`;
    };

    if (!alarms || alarms.length === 0) {
        return null;
    }

    return (
        <div className="alarms-card">
            <div className="alarms-card-header">
                <h3>Alarms</h3>
            </div>
            <div className="alarms-table-container">
                <table className="alarms-table">
                    <thead>
                        <tr>
                            <th>Alarm Name</th>
                            <th>Alarm Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {alarms.map(alarm => {
                            // Use color from API if available, otherwise fall back to active/inactive logic
                            const indicatorColor =
                                alarm.color ||
                                (alarm.isActive ? '#f44336' : '#4caf50');

                            return (
                                <tr key={alarm.id}>
                                    <td>{alarm.alarmName}</td>
                                    <td>
                                        <div className="alarm-status">
                                            <span
                                                className="alarm-status-indicator"
                                                style={{
                                                    backgroundColor: indicatorColor
                                                }}
                                            ></span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AlarmsCard;
